import axios from "axios";

import { loadStoredSession } from "../../features/auth/storage";
import { fetchAuthenticatedUser } from "./auth";
import { ensureCsrfCookie } from "./csrf";
import type { AuthenticatedUser } from "./types";

const MAX_ATTEMPTS = 3;

export type AuthSessionResolveResult =
    | { status: "authenticated"; user: AuthenticatedUser }
    | { status: "guest" }
    | { status: "offline-dev"; user: AuthenticatedUser };

export async function resolveAuthSession(): Promise<AuthSessionResolveResult> {
    const stored = loadStoredSession();
    let backendUnavailable = false;

    try {
        await ensureCsrfCookie();
    } catch {
        // Продължаваме — /auth/me може да мине и без нов CSRF cookie.
    }

    for (let attempt = 0; attempt < MAX_ATTEMPTS; attempt += 1) {
        try {
            const user = await fetchAuthenticatedUser();

            return { status: "authenticated", user };
        } catch (error) {
            if (axios.isAxiosError(error) && error.response?.status === 419 && attempt < MAX_ATTEMPTS - 1) {
                await ensureCsrfCookie();
                continue;
            }

            backendUnavailable = axios.isAxiosError(error) && !error.response;
            break;
        }
    }

    if (import.meta.env.DEV && backendUnavailable && stored.user) {
        return { status: "offline-dev", user: stored.user };
    }

    return { status: "guest" };
}
